import React from 'react'
import collapse1 from "../../Assets/new_horizontal/1.svg";
import collapse2 from "../../Assets/new_horizontal/2.svg";
import collapse3 from "../../Assets/new_horizontal/3.svg";
import collapse4 from "../../Assets/new_horizontal/4.svg";
import collapse5 from "../../Assets/new_horizontal/5.svg";
import collapse6 from "../../Assets/new_horizontal/6.svg";
import collapse7 from "../../Assets/new_horizontal/7.svg";
import collapse8 from "../../Assets/new_horizontal/8.svg";
import collapse9 from "../../Assets/new_horizontal/9.svg";
import collapse10 from "../../Assets/new_horizontal/10.svg";
import collapse11 from "../../Assets/new_vertical/12.svg";
import Slider from 'react-slick';
import { NextArrow, PrewArrow } from "./Arrows"

function HorizontalCollapse({ selectedCollapse, handleSetCollapse }) {

    const Json = [
        { index: 0, image: collapse1, screen: [{ i: 0, width: 100 }] },
        { index: 1, image: collapse2, screen: [{ i: 0, height: 90 }, { i: 1, scrollBottom: 10, text: "" }] },
        { index: 2, image: collapse3, screen: [{ direction: "horizontal", height: 100, smallScreen: [{ i: 0, width: 50 }, { i: 1, width: 50 }] }] },
        { index: 3, image: collapse4, screen: [{ i: 1, scrollTop: 10, text: "" }, { i: 0, height: 90 }] },
        { index: 4, image: collapse5, screen: [{ i: 1, scrollTop: 10, text: "" }, { i: 0, height: 80 }, { i: 2, scrollBottom: 10, text: "" }] },
        { index: 5, image: collapse6, screen: [{ direction: "horizontal", height: 90, smallScreen: [{ i: 0, width: 25 }, { i: 1, width: 75 }] }, { i: 2, scrollBottom: 10, text: "" }] },
        { index: 6, image: collapse7, screen: [{ direction: "horizontal", height: 90, smallScreen: [{ i: 0, width: 75 }, { i: 1, width: 25 }] }, { i: 2, scrollBottom: 10, text: "" }] },
        { index: 7, image: collapse8, screen: [{ i: 2, scrollTop: 10, text: "" }, { direction: "horizontal", height: 90, smallScreen: [{ i: 0, width: 25 }, { i: 1, width: 75 }] }] },
        { index: 8, image: collapse9, screen: [{ i: 2, scrollTop: 10, text: "" }, { direction: "horizontal", height: 90, smallScreen: [{ i: 0, width: 75 }, { i: 1, width: 25 }] }] },
        { index: 9, image: collapse10, screen: [{ i: 1, scrollTop: 10, text: "" }, { direction: "horizontal", height: 80, smallScreen: [{ i: 0, width: 50 }, { i: 3, width: 50 }] }, { i: 2, scrollBottom: 10, text: "" }] },
        { index: 10, image: collapse11, screen: [{ direction: 'vertical', width: 100, height: 100, smallScreen: [{ i: 0, height: 33.33 }, { i: 1, height: 33.33 }, { i: 2, height: 33.34 }] }] },
        // { index: 11, image: collapse11, screen: [{ direction: 'horizontal', height: 100, smallScreen: [{ i: 0, width: 33.33 }, { i: 1, width: 33.33 }, { i: 2, width: 33.34 }] }] },
    ];

    const settings = {
        // dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        // prevArrow: <PrewArrow />,
        // nextArrow: <NextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <>
            <Slider {...settings}>
                {Json?.map((item, i) => {
                    return (
                        <div style={{ margin: "5px", border: selectedCollapse?.index === item?.index ? "2px solid black" : '' }}>
                            <img
                                src={item?.image}
                                className="card-img-top"
                                height={110}
                                width={110}
                                alt="image not found"
                                onClick={() => handleSetCollapse(item)}
                                style={{ border: selectedCollapse?.index === item?.index ? "2px solid black" : '' }}
                            />
                            <p style={{ margin: 0 }}>{i + 1}</p>
                        </div>
                    )
                })}
            </Slider>
        </>
    )
}

export default HorizontalCollapse